<template>
  <header class="header">
    <div class="header__container">
      <div class="header__aligner">
        <div class="header__left">
          <div class="header__logo">
            <img src="../assets/images/logos/diaceutics-logo--light.svg" alt="Diaceutics" />
          </div>
          <div class="header__bank">
            <p>Brand Bank</p>
          </div>
        </div>
        <div class="header__right">
          <span v-if="store.token" class="logged_in">Logged in as {{ store.email }},</span>
          <span v-if="store.token" @click="logout" class="logout">logout?</span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { store, mutations } from "../utils/store";

export default {
  computed: {
    store() {
      return store
    }
  },
  methods: {
    logout() {
      mutations.logout()
      this.$router.push("/login")
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../styles/_mixins.scss';
  
  .header {
    height: 85px;
    background-color: var(--brand-purple);
    color: var(--white);

    &__aligner {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: flex-end;
    }

    &__container {
      height: 100%;
      width: 100%;
      padding: 0 28px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      @include bp(575px) {
        padding: 0 18px;
      }
    }

    &__left {
      display: flex;
      align-items: flex-end;
    }

    &__right {
      text-align: right;
      margin-bottom: -2px;
    }

    &__left {
      @include bp(575px) {
        flex-direction: column;
        align-items: flex-start;
        white-space: nowrap;
        padding-right:20px;
      }
    }

    &__logo {
      width: 120px;
      margin-right: 26px;

      @include bp(575px) {
        display: none;
      }
    }

    &__bank {
      margin-bottom: -1px;

      @include bp(575px) {
        margin-bottom: 0;
      }

      p {
        font-weight: bold;
        font-size: 14px;
        color: #fff;
        line-height: 14px;
        color: var(--text-pink);

        @include bp(375px) {
          font-size: 0.75em;
        }
      }
    }

    .logged_in {
      font-family: var(--f-regular);
      font-size: 14px;
    }

    .logout {
      margin-left: 6px;
      cursor: pointer;
      font-family: var(--f-semi);
      font-size: 14px;
    }
  }
</style>